import React, { Component } from "react";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import WinterMaintenceRegionsTools from "./WinterMaintenceRegionsTools";
import WinterParentCompanyTools from "./WinterParentCompanyTools";

class WinterMaintenceAreasTools extends Component {
  render() {
    const { winterArea, winterAreasFilter } = this.props;

    const currentFilter = winterAreasFilter.filter((x) => {
      return x.winterAreaId === winterArea.id;
    })[0];

    return (
      <div>
        <h3>{winterArea.title}</h3>
        <WinterMaintenceRegionsTools winterArea={winterArea} currentFilter={currentFilter} />
        {winterArea.parentCompanies.map((x) => {
          return (
            <div key={x.id}>
              <WinterParentCompanyTools winterArea={winterArea} parentCompany={x} currentFilter={currentFilter} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceAreasTools));
